var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3df6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb53de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c48fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb53de"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69231",
    "data-name": "Group 69231",
    transform: "translate(19854 11049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2377",
    "data-name": "Ellipse 2377",
    transform: "translate(-19854 -11049)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69232",
    "data-name": "Group 69232",
    transform: "translate(34 -45.706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17344",
    "data-name": "Rectangle 17344",
    width: 6,
    height: 17,
    rx: 3,
    transform: "translate(-19858.152 -10990)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17345",
    "data-name": "Rectangle 17345",
    width: 6,
    height: 18,
    rx: 3,
    transform: "translate(-19870.848 -10990.589) rotate(30)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17346",
    "data-name": "Rectangle 17346",
    width: 6,
    height: 18,
    rx: 3,
    transform: "translate(-19873.348 -10987.589) rotate(-30)",
    fill: "url(#linear-gradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.8983b59bf100f78428521f5260e70be9.svg";
export { ForwardRef as ReactComponent };